/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  SessionResponse,
  SessionResponseFromJSON,
  SessionResponseToJSON,
  SignInMessageResponse,
  SignInMessageResponseFromJSON,
  SignInMessageResponseToJSON,
  SignedSignInToNominexDomain,
  SignedSignInToNominexDomainFromJSON,
  SignedSignInToNominexDomainToJSON,
} from '../models'

export interface GetSignInMessageRequest {
  address?: string
  referrerId?: number
}

export interface SigninRequest {
  signedSignInToNominexDomain?: SignedSignInToNominexDomain
}

/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
  /**
   */
  async getSessionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<SessionResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/session`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseFromJSON(jsonValue))
  }

  /**
   */
  async getSession(initOverrides?: RequestInit): Promise<SessionResponse> {
    const response = await this.getSessionRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getSignInMessageRaw(
    requestParameters: GetSignInMessageRequest,
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<SignInMessageResponse>> {
    const queryParameters: any = {}

    if (requestParameters.address !== undefined) {
      queryParameters['address'] = requestParameters.address
    }

    if (requestParameters.referrerId !== undefined) {
      queryParameters['referrerId'] = requestParameters.referrerId
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/public/messages/signin`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => SignInMessageResponseFromJSON(jsonValue))
  }

  /**
   */
  async getSignInMessage(
    requestParameters: GetSignInMessageRequest = {},
    initOverrides?: RequestInit,
  ): Promise<SignInMessageResponse> {
    const response = await this.getSignInMessageRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async signinRaw(requestParameters: SigninRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/private/messages/signin`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SignedSignInToNominexDomainToJSON(requestParameters.signedSignInToNominexDomain),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   */
  async signin(requestParameters: SigninRequest = {}, initOverrides?: RequestInit): Promise<void> {
    await this.signinRaw(requestParameters, initOverrides)
  }
}
